import React, { FC } from 'react';

import { Title, TitleProps } from '@mantine/core';

const ModalTitle: FC<
    TitleProps & {
        title?: string;
        align?: TitleProps['ta'];
        children?: React.ReactNode;
    }
> = ({ title = '', align = 'center', children = null, ...props }) => (
    <Title fz={20} fw={600} lh={1.2} ta={align} {...props}>
        {children || title}
    </Title>
);

export { ModalTitle };
